import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../lib/api';

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const u = localStorage.getItem('tg_user');
    return u ? JSON.parse(u) : null;
  });
  const [loading, setLoading] = useState(() => !!localStorage.getItem('tg_token'));

  useEffect(() => {
    const token = localStorage.getItem('tg_token');
    if (!token) return;
    api.get('/auth/me')
      .then((res) => {
        setUser(res.data);
        localStorage.setItem('tg_user', JSON.stringify(res.data));
      })
      .catch(() => {
        localStorage.removeItem('tg_token');
        localStorage.removeItem('tg_user');
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const persist = (data) => {
    localStorage.setItem('tg_token', data.token);
    localStorage.setItem('tg_user', JSON.stringify(data.user));
    setUser(data.user);
  };

  const login = async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    persist(res.data);
    return res.data;
  };

  const register = async (name, email, password) => {
    const res = await api.post('/auth/register', { name, email, password });
    persist(res.data);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('tg_token');
    localStorage.removeItem('tg_user');
    setUser(null);
    window.location.href = '/login';
  };

  const updateUser = (data) => {
    setUser(data);
    localStorage.setItem('tg_user', JSON.stringify(data));
  };

  // Establish a session directly from an auth payload ({ token, user }),
  // e.g. after accepting a team invitation.
  const setSession = (data) => {
    persist(data);
    return data;
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, updateUser, setSession }}>
      {children}
    </AuthContext.Provider>
  );
};
